import { SEASONAL_LEAD_DAYS, daysUntil, nthSunday } from './seasonalDates'

// Relationship chips pulled to the front of "Who's it for?" while a gift-giving
// day is near — Mom/Grandma/Sister for Mother's Day, the romantic set for
// Valentine's, and so on. Matched by LABEL, not canonical value: Grandma and
// Grandpa both resolve to `grandparent`, so only the label tells them apart.
// Same lead window as the seasonal occasions, so the two move in step; when two
// windows overlap the nearer day's picks lead.
type SeasonalRelationship = { labels: string[], date: (year: number) => Date }

const SEASONAL: SeasonalRelationship[] = [
  { labels: ['Mom', 'Grandma', 'Sister'], date: year => nthSunday(year, 4, 2) },
  { labels: ['Dad', 'Grandpa', 'Brother'], date: year => nthSunday(year, 5, 3) },
  { labels: ['Spouse', 'Girlfriend', 'Boyfriend', 'Wife', 'Husband', 'Partner'], date: year => new Date(year, 1, 14) },
  { labels: ['Friend', 'Best friend'], date: year => nthSunday(year, 7, 1) },
]

export function seasonalRelationshipLabels (today: Date): string[] {
  return SEASONAL
    .map(entry => ({ entry, days: daysUntil(entry.date, today) }))
    .filter(({ days }) => days <= SEASONAL_LEAD_DAYS)
    .sort((a, b) => a.days - b.days)
    .flatMap(({ entry }) => entry.labels)
}
